import "./Buttons.css";

export default function Buttons() {
  return (
    <section className="ui-kit-section">
      <h2 className="ui-kit-title">Buttons</h2>

      <div className="ui-btnkit">
        <div />
        <div className="ui-btnkit__colTitle">default</div>
        <div className="ui-btnkit__colTitle">pressed</div>

        {/* main button (38) */}
        <div className="ui-btnkit__label">
          <div className="ui-btnkit__labelTitle">main button</div>
          <div className="ui-btnkit__labelSub">(38)</div>
        </div>

        <div className="ui-btnkit__cell">
          <PrimaryButton size={38} w={180}>
            ADD TO BAG
          </PrimaryButton>
        </div>

        <div className="ui-btnkit__cell">
          <PrimaryButton size={38} w={180} pressed>
            ADD TO BAG
          </PrimaryButton>
        </div>

        {/* main button (44) */}
        <div className="ui-btnkit__label">
          <div className="ui-btnkit__labelTitle">main button</div>
          <div className="ui-btnkit__labelSub">(44)</div>
        </div>

        <div className="ui-btnkit__cell">
          <PrimaryButton size={44} w={280}>
            BUY - $170,00
          </PrimaryButton>
        </div>

        <div className="ui-btnkit__cell">
          <PrimaryButton size={44} w={280} pressed>
            BUY - $170,00
          </PrimaryButton>
        </div>
      </div>
    </section>
  );
}

/**
 * PrimaryButton — щоб потім використовувати в проекті
 * size: 38 | 44
 * w: width px (Fixed)
 * pressed: показати pressed стан як в UI kit
 */
export function PrimaryButton({ size = 38, w = 180, pressed = false, className = "", ...props }) {
  const cls = [
    "ui-primaryBtn",
    size === 44 ? "ui-primaryBtn--44" : "ui-primaryBtn--38",
    pressed ? "ui-primaryBtn--pressed" : "",
    className
  ].join(" ").trim();

  return (
    <button
      type="button"
      className={cls}
      style={{ "--btn-w": `${w}px` }}
      {...props}
    />
  );
}
